import React, { useState } from "react";
import ContactManagement from "./ContactManagement";
import QueryManagement from "../QueryManagement/QueryManagement";
import WebinarManagement from "../WebinarManagement/WebinarManagement";
import { FaAddressBook, FaQuestionCircle, FaVideo } from 'react-icons/fa';

const ContactsHub = () => {
  const [activeTab, setActiveTab] = useState("forms");

  const tabs = [
    { id: "forms", label: "Contact Forms", icon: <FaAddressBook className="w-4 h-4" /> },
    { id: "queries", label: "Queries", icon: <FaQuestionCircle className="w-4 h-4" /> },
    { id: "webinar", label: "Webinar Form", icon: <FaVideo className="w-4 h-4" /> },
  ];

  return (
    <div className="pt-0 space-y-0 animate-in fade-in duration-500">
      {/* Tab Navigation Section */}
      <div className="px-4 lg:px-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-end gap-6 mb-2">
          
          <div className="bg-gray-100/80 dark:bg-dark-700/50 backdrop-blur-sm p-1.5 rounded-2xl flex items-center gap-1 border border-gray-200/50 dark:border-dark-600/30">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-xs font-black uppercase tracking-widest transition-all duration-300 ${
                  activeTab === tab.id
                    ? "bg-white dark:bg-dark-800 text-primary-600 shadow-xl shadow-gray-200/50 dark:shadow-none scale-105"
                    : "text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                }`}
              >
                {tab.icon}
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="transition-all duration-500">
        {activeTab === "forms" ? (
          <ContactManagement />
        ) : activeTab === "queries" ? (
          <QueryManagement />
        ) : (
          <WebinarManagement />
        )}
      </div>
    </div>
  );
};

export default ContactsHub;
